// extracted by mini-css-extract-plugin
export default {"progress__container":"styles_progress__container__8VkLt","progress__content-value":"styles_progress__content-value__eF+dU"};